import { Runtime } from '@/core/enums/runtime.enum'
import { PACKAGE_MANAGER_MAP } from '@/core/utils/installation'

export const CODES_QUERY_KEY = ['codes'] as const

const UNKNOWN_PACKAGE_MANAGER = 'unknown-package-manager'

export const getPackageManager = (runtimeName?: Runtime): string =>
  runtimeName ? PACKAGE_MANAGER_MAP[runtimeName] : UNKNOWN_PACKAGE_MANAGER
